import { formatDistance } from '@helpers/getDistance';
import { FC } from 'react';
import { PropsDistance } from '@models/Shop/components';
import classNames from 'classnames';
import { IconGeo } from '@koleso-icons';

import styles from './BlockDistance.module.scss';

export const BlockDistance: FC<PropsDistance> = ({ distance, className, hideIcon }) => {
  const text = formatDistance(distance);
  if (!distance) {
    return null;
  }
  return (
    <div className={classNames(styles.Container, hideIcon && styles.hideIcon, className)}>
      <div className={classNames(styles.BlockDistance, { [styles.Red]: text === 'Вы рядом' })}>
        {!hideIcon && <IconGeo width={16} height={16} />}
        <p>{text}</p>
      </div>
    </div>
  );
};
